// Color palette extracted from Figma Design System
// https://www.figma.com/design/Nd4ormSkjEzEE1y9SAjTsp/InDebted-Brand---Design-Bible-2025?node-id=1525-271581&m

export const colors = {
	primary: {
		white: "#FFFFFF",
		black: "#000000",
		pink: "#EE46BC",
	},
	endlessGalaxy: {
		"25": "#E3E6EE",
		"50": "#C7CEDD",
		"100": "#ACB6CB",
		"200": "#919FBA",
		"300": "#7888A9",
		"400": "#5F7299",
		"500": "#475C88",
		"600": "#304777",
		"700": "#1B3166",
		"800": "#071C55",
		"900": "#000244",
	},
	warmBlue: {
		"25": "#ECF0FE",
		"50": "#D9E0FD",
		"100": "#C6D1FB",
		"200": "#B4C1F8",
		"300": "#A3B2F6",
		"400": "#91A2F3",
		"500": "#8192EF",
		"600": "#7182EB",
		"700": "#6271E7",
		"800": "#545FE3",
		"900": "#474CDE",
	},
	tiffanyBlue: {
		"25": "#F4FDFC",
		"50": "#E9FCFA",
		"100": "#DEFAF7",
		"200": "#D3F8F4",
		"300": "#C7F7F2",
		"400": "#BBF5EF",
		"500": "#AFF3ED",
		"600": "#A2F1EA",
		"700": "#94EFE7",
		"900": "#76EBE2",
	},
	summerMist: {
		"25": "#FAFEFD",
		"50": "#F5FDFC",
		"100": "#F1FCFA",
		"200": "#ECFAF9",
		"300": "#E7F9F7",
		"400": "#E2F8F6",
		"500": "#DDF7F4",
		"600": "#D8F6F3",
		"700": "#D3F4F1",
		"800": "#CEF3F0",
		"900": "#C9F2EE",
	},
	meltingGlacier: {
		"25": "#FDFEFE",
		"50": "#FAFEFD",
		"100": "#F8FDFD",
		"200": "#F6FCFC",
		"300": "#F3FBFB",
		"400": "#F1FBFA",
		"500": "#EFFAF9",
		"600": "#ECF9F8",
		"700": "#EAF8F8",
		"800": "#E7F8F7",
		"900": "#E5F7F6",
	},
	purpleIllusion: {
		"25": "#F9F9FE",
		"50": "#F3F3FD",
		"100": "#ECEDFC",
		"200": "#E6E8FB",
		"300": "#E0E2FA",
		"400": "#DADCF9",
		"500": "#D4D6F7",
		"600": "#CED0F6",
		"700": "#C9CBF5",
		"800": "#C3C5F3",
		"900": "#BDBFF2",
	},
	spaceBattleBlue: {
		"25": "#E9EBF8",
		"50": "#D4D6F1",
		"100": "#C0C2E9",
		"200": "#ACAEE1",
		"300": "#989AD9",
		"400": "#8686D0",
		"500": "#7472C7",
		"600": "#635EBE",
		"700": "#5348B4",
		"800": "#4531AA",
		"900": "#390FA0",
	},
	heron: {
		"25": "#F0F0F5",
		"50": "#E0E1EB",
		"100": "#D1D2E1",
		"200": "#C3C4D7",
		"300": "#B4B6CD",
		"400": "#A6A7C3",
		"500": "#9899B9",
		"600": "#8A8BB0",
		"700": "#7C7EA6",
		"800": "#6F709C",
		"900": "#626392",
	},
	nobleKnight: {
		"25": "#ECEDF3",
		"50": "#D9DAE7",
		"100": "#C6C9DC",
		"200": "#B4B7D0",
		"300": "#A2A5C4",
		"400": "#9194B8",
		"500": "#8083AC",
		"600": "#6F73A1",
		"700": "#5F6295",
		"800": "#505289",
		"900": "#41427D",
	},
	etherealMist: {
		"25": "#F8F8FA",
		"50": "#F0F0F6",
		"100": "#E9E9F1",
		"200": "#E2E2EC",
		"300": "#DADBE8",
		"400": "#D3D4E3",
		"500": "#CCCDDF",
		"600": "#C5C6DA",
		"700": "#BEBFD5",
		"800": "#B7B8D1",
		"900": "#B0B1CC",
	},
	blueMana: {
		"25": "#F2F9FE",
		"50": "#E5F3FD",
		"100": "#D7EDFB",
		"200": "#CAE8FA",
		"300": "#BDE2F8",
		"400": "#AFDCF7",
		"500": "#A1D6F5",
		"600": "#93CFF4",
		"700": "#85C9F2",
		"800": "#76C3F0",
		"900": "#66BDEE",
	},
	gray: {
		"25": "#FDFDFD",
		"50": "#FAFAFA",
		"100": "#F6F6F6",
		"200": "#E9EAEB",
		"300": "#D5D7DA",
		"400": "#A4A7AE",
		"500": "#717680",
		"600": "#535862",
		"700": "#414651",
		"800": "#252B37",
		"900": "#101828",
	},
	error: {
		"25": "#FFFBFA",
		"50": "#FEF3F2",
		"100": "#FEE4E2",
		"200": "#FECDCA",
		"300": "#FDA29B",
		"400": "#F97066",
		"500": "#F04438",
		"600": "#D92D20",
		"700": "#B42318",
		"800": "#912018",
		"900": "#7A271A",
	},
	warning: {
		"25": "#FFFCF5",
		"50": "#FFFAEB",
		"100": "#FEF0C7",
		"200": "#FEDF89",
		"300": "#FEC84B",
		"400": "#FDB022",
		"500": "#F79009",
		"600": "#DC6803",
		"700": "#B54708",
		"800": "#93370D",
		"900": "#7A2E0E",
	},
	success: {
		"25": "#F6FEF9",
		"50": "#ECFDF3",
		"100": "#D1FADF",
		"200": "#A6F4C5",
		"300": "#6CE9A6",
		"400": "#32D583",
		"500": "#12B76A",
		"600": "#039855",
		"700": "#027A48",
		"800": "#05603A",
		"900": "#054F31",
	},
	blue: {
		"25": "#F5FAFF",
		"50": "#EFF8FF",
		"100": "#D1E9FF",
		"200": "#B2DDFF",
		"300": "#84CAFF",
		"400": "#53B1FD",
		"500": "#2E90FA",
		"600": "#1570EF",
		"700": "#175CD3",
		"800": "#1849A9",
		"900": "#194185",
	},
} as const

// Gradients using existing color palette
export const gradients = {
	// Gray Gradients
	"gray-600-to-500-90deg": `linear-gradient(90deg, ${colors.gray["600"]}, ${colors.gray["500"]})`,
	"gray-700-to-600-45deg": `linear-gradient(45deg, ${colors.gray["700"]}, ${colors.gray["600"]})`,
	"gray-800-to-600-45deg": `linear-gradient(45deg, ${colors.gray["800"]}, ${colors.gray["600"]})`,
	"gray-800-to-600-90deg": `linear-gradient(90deg, ${colors.gray["800"]}, ${colors.gray["600"]})`,
	"gray-800-to-700-26deg": `linear-gradient(26.5deg, ${colors.gray["800"]}, ${colors.gray["700"]})`,
	"gray-900-to-600-45deg": `linear-gradient(45deg, ${colors.gray["900"]}, ${colors.gray["600"]})`,

	// Brand Gradients
	"brand-gradient-1-90deg": `linear-gradient(90deg, ${colors.meltingGlacier["900"]}, ${colors.tiffanyBlue["600"]})`,
	"brand-gradient-2-90deg": `linear-gradient(90deg, ${colors.blueMana["900"]}, ${colors.tiffanyBlue["600"]})`,
	"brand-gradient-3-90deg": `linear-gradient(90deg, ${colors.warmBlue["900"]}, ${colors.purpleIllusion["900"]})`,
	"brand-gradient-4-90deg": `linear-gradient(90deg, ${colors.spaceBattleBlue["900"]}, #110852)`,
	"brand-gradient-5-90deg": `linear-gradient(90deg, ${colors.blueMana["900"]}, ${colors.warmBlue["900"]})`,
	"brand-gradient-6-90deg": `linear-gradient(90deg, ${colors.warmBlue["900"]}, ${colors.spaceBattleBlue["900"]})`,
	"brand-gradient-7-90deg": `linear-gradient(90deg, ${colors.blue["300"]}, ${colors.tiffanyBlue["900"]})`,
} as const
